import { SyncIcon, UploadIcon } from "@primer/octicons-react";
import { Box } from "@primer/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ComboboxHe } from "../../components/combobox-he";
import ComboboxKhoi from "../../components/combobox-khoi";
import { ComboboxTruong } from "../../components/combobox-truong";
import { AnimationConfirm } from "../../components/confirm";
import SelectBoxMultipleHinhThucMienGiam from "../../components/selectbox-multiple-hinhthucmiengiam";
import Button from "../../components/ui/button";
import DataGrid from "../../components/data-grid";
import { IDataGridColumn } from "../../components/data-grid/type/IDataGridProps";
import Text from "../../components/ui/text";
import TextWithEllipse from "../../components/ui/text-with-ellipse";
import { localStorageHelper } from "../../helpers/localStorage";
import { PageBaseStatus } from "../../models/pageBaseStatus";
import { ganMienGiamFilterStudentModel } from "../../models/request/gan-mien-giam/ganMienGiamFilterStudent";
import { ganMienGiamHocSinhRequest } from "../../models/request/gan-mien-giam/ganMienGiamHocSinhRequest";
import {
  approveGanMienGiamCancel,
  approveGanMienGiamSubmit,
  changeGanMienGiamFilterStudent,
  changeHe,
  changeKhoi,
  changeTruong,
  closeGanMienGiamFilterStudentModal,
  closeGanMienGiamImportModal,
  ganMienGiamHocSinhStart,
  loadGanMienGiamHinhThucMienGiamStart,
  loadGanMienGiamHocSinhStart,
  loadGanMienGiamStart,
  showGanMienGiamImportModal,
} from "../../state/actions/ganMienGiamActions";
import { RootState } from "../../state/reducers";
import { GanMienGiamFilterStudentModal } from "./filter-student-modal";
import styles from "./GanMienGiamPage.module.css";
import { GanMienGiamImportModal } from "./import-modal/GanMienGiamImportModal";

const GanMienGiamNewPage = () => {
  const state = useSelector((x: RootState) => x.ganMienGiam);
  const dispatch = useDispatch();
  const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);
  const [hinhThucMienGiamFilter, setHinhThucMienGiamFilter] = useState<
    number[]
  >([]);

  const {
    //filter,
    is_show_filter_student_modal,
    filterStudent,
    sf_dexuatmiengiams,
    status,
    ts_hocsinhs,
    approve_request,
    is_show_approve_confirm,
    is_show_import_modal,
    dm_he_id,
    dm_khoi_id,
    dm_truong_id,
    nhom_mien_giam_id,
    hinh_thuc_mien_giam_ids,
  } = state;
  const sf_hinhthucmiengiams = useMemo(() => {
    return state.sf_hinhthucmiengiams.filter((x) => x.dm_coso_id == dm_coso_id);
  }, [state.sf_hinhthucmiengiams, dm_coso_id]);
  const ts_hocsinh_ids = useMemo(() => {
    return ts_hocsinhs.map((x) => x.id);
  }, [ts_hocsinhs]);
  useEffect(() => {
    if (
      status == PageBaseStatus.is_need_reload ||
      status == PageBaseStatus.is_not_initial
    ) {
      dispatch(loadGanMienGiamHinhThucMienGiamStart(nam_hoc));
    }
  }, [status]);
  useEffect(() => {
    if (nam_hoc !== "") {
      dispatch(loadGanMienGiamHinhThucMienGiamStart(nam_hoc));
    }
  }, [nam_hoc]);

  useEffect(() => {
    dispatch(
      loadGanMienGiamHocSinhStart({
        dm_he_id: dm_he_id,
        dm_khoi_id: dm_khoi_id,
        dm_truong_id: dm_truong_id,
        nam_hoc: nam_hoc,
      })
    );
    dispatch(
      loadGanMienGiamStart({
        dm_he_id: dm_he_id,
        dm_khoi_id: dm_khoi_id,
        dm_truong_id: dm_truong_id,
        nam_hoc: nam_hoc,
      })
    );
    localStorageHelper.setNamHocTruongKhoiFilter({
      dm_he_id: dm_he_id !== undefined ? dm_he_id : 0,
      dm_khoi_id: dm_khoi_id !== undefined ? dm_khoi_id : 0,
      dm_truong_id: dm_truong_id !== undefined ? dm_truong_id : 0,
      nam_hoc: nam_hoc,
    });
  }, [dm_he_id, dm_khoi_id, dm_truong_id, nam_hoc, dm_coso_id]);

  useEffect(() => {
    if (status === PageBaseStatus.is_need_reload)
      dispatch(
        loadGanMienGiamStart({
          dm_he_id: dm_he_id,
          dm_khoi_id: dm_khoi_id,
          dm_truong_id: dm_truong_id,
          nam_hoc: nam_hoc,
        })
      );
  }, [status]);

  const handleApprove = async (
    sf_hinhthucmiengiam_id: number,
    is_approved: boolean
  ) => {
    dispatch(
      approveGanMienGiamSubmit({
        dm_he_id: dm_he_id,
        dm_khoi_id: dm_khoi_id,
        dm_truong_id: dm_truong_id,
        nam_hoc: nam_hoc,
        is_approved: is_approved,
        sf_hinhthucmiengiam_id: sf_hinhthucmiengiam_id,
        ts_hocsinh_ids: ts_hocsinh_ids,
      })
    );
  };
  const handleGanMienGiam = useCallback(
    async (
      ts_hocsinh_id: number,
      nam_hoc: string,
      sf_hinhthucmiengiam_ids: number[]
    ) => {
      const data_send: ganMienGiamHocSinhRequest = {
        ts_hocsinh_id: ts_hocsinh_id,
        nam_hoc: nam_hoc,
        sf_hinhthucmiengiam_ids: sf_hinhthucmiengiam_ids,
      };
      dispatch(ganMienGiamHocSinhStart(data_send));
      setTimeout(() => {
        dispatch(
          loadGanMienGiamStart({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc,
          })
        );
      }, 200);
    },
    [dispatch, dm_he_id, dm_khoi_id, dm_truong_id]
  );
  const dataSource = useMemo(() => {
    let ts_hocsinhs_temp = ts_hocsinhs;
    let sf_hinhthucmiengiams_temp = sf_hinhthucmiengiams;
    const result = ts_hocsinhs_temp.map((x) => {
      const sf_dexuatmiengiam_hocsinhs = sf_dexuatmiengiams.filter(
        (y) => y.ts_hocsinh_id === x.id
      );
      let item: any = {
        id: x.id,
        ma_hs: x.ma_hs,
        ho_ten: x.ho_ten,
        ngay_sinh: x.ngay_sinh,
        trang_thai: x.trang_thai || x.dm_trangthaihocsinh_trang_thai,
        ten_truong: x.ten_truong,
        ten_khoi: x.ten_khoi,
        ten_he: x.ten_he,
        ten_lop: x.ten_lop,
      };
      let summary: string[] = [];
      let sf_hinhthucmiengiam_ids: number[] = [];
      sf_hinhthucmiengiams_temp.forEach((x) => {
        if (x.so_lan_huong_toi_da <= 1) {
          item["M_" + x.id] = false;
        }
      });
      for (let i = 0; i < sf_dexuatmiengiam_hocsinhs.length; i++) {
        const sf_hinhthucmiengiam_id =
          sf_dexuatmiengiam_hocsinhs[i].sf_hinhthucmiengiam_id;
        const so_lan_ap_dung = sf_dexuatmiengiam_hocsinhs[i].so_lan_ap_dung;
        const sf_hinhthucmiengiam = sf_hinhthucmiengiams_temp.find(
          (x) => x.id === sf_hinhthucmiengiam_id
        );
        item = Object.assign({}, item, {
          ["M_" + sf_hinhthucmiengiam_id]:
            sf_hinhthucmiengiam?.so_lan_huong_toi_da === 1
              ? true
              : so_lan_ap_dung,
        });
        summary.push(
          sf_hinhthucmiengiam
            ? `* ${sf_hinhthucmiengiam.hinh_thuc_mien_giam}`
            : ""
        );
        sf_hinhthucmiengiam_ids.push(sf_hinhthucmiengiam_id);
      }
      item = Object.assign({}, item, { summary: summary.join("\n") });
      item = Object.assign({}, item, {
        sf_hinhthucmiengiam_ids: sf_hinhthucmiengiam_ids,
      });

      return item;
    });
    return result;
  }, [
    ts_hocsinhs,
    sf_dexuatmiengiams,
    sf_hinhthucmiengiams,
    nhom_mien_giam_id,
    hinh_thuc_mien_giam_ids,
  ]);
  const renderThaoTac = useCallback(
    (data: any) => {
      return (
        <Box sx={{ color: "fg.muted" }}>
          <SelectBoxMultipleHinhThucMienGiam
            value={data.sf_hinhthucmiengiam_ids}
            onValueChanged={(value) => {
              debugger;
              handleGanMienGiam(data.id, nam_hoc, value);
            }}
            sf_hinhthucmiengiams={sf_hinhthucmiengiams}
          />
        </Box>
      );
    },
    [sf_hinhthucmiengiams, handleGanMienGiam, nam_hoc]
  );
  const columns = useMemo<IDataGridColumn[]>(() => {
    let result: IDataGridColumn[] = [
      // {
      //   caption: "Trạng thái",
      //   id: "trang_thai",
      //   dataField: "trang_thai",
      //   width: 120,
      //   isMainColumn: true,
      //   cellRender: (data: any) => {
      //     let color: any = "fg.default";
      //     switch (data.trang_thai) {
      //       case "New Enrollment":
      //         color = "accent.emphasis";
      //         break;
      //       case "Thôi học":
      //         color = "danger.emphasis";
      //         break;
      //       case "Đang học":
      //         color = "primary.emphasis";
      //         break;
      //       case "Học sinh lên lớp chưa đóng phí":
      //         color = "attention.emphasis";
      //         break;

      //       default:
      //         break;
      //     }
      //     return (
      //       <Box
      //         sx={{
      //           color: color,
      //         }}
      //       >
      //         <TextWithEllipse text={data.trang_thai} lineNumber={1} />
      //       </Box>
      //     );
      //   },
      // },
      {
        dataField: "ho_ten",
        width: 160,
        caption: "Học sinh",
        cellRender: (data: any) => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "baseline",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box sx={{ fontWeight: 600 }}>{data.ho_ten}</Box>
              </Box>
              <Box sx={{ color: "fg.muted" }}>{data.ma_hs}</Box>
            </Box>
          );
        },
      },
      {
        dataField: "ten_truong",
        id: "ten_truong",
        caption: "Trường lớp",
        width: 160,
        cellRender: (data: any) => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "baseline",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box sx={{ fontWeight: 600 }}>{data.ten_lop}</Box>
              </Box>
              <Box sx={{ color: "fg.muted" }}>
                {data.ten_khoi}, Hệ {data.ten_he}
              </Box>
            </Box>
          );
        },
      },
      {
        caption: "Miễn giảm đang áp dụng",
        id: "summary",
        dataField: "summary",
        width: 300,
        cellRender: (data: any) => {
          return (
            <Box sx={{ color: "fg.muted" }}>
              <TextWithEllipse text={`${data.summary ?? ""}`} lineNumber={1} />
            </Box>
          );
        },
      },
      {
        caption: "Gán miễn giảm",
        id: "thao_tac",
        dataField: "thao_tac",
        width: 200,
        cellRender: renderThaoTac,
      },
    ];

    return result;
  }, [dataSource, renderThaoTac]);
  return (
    <Box className={styles.container} sx={{ p: 2 }}>
      <Box className="col-md-12" sx={{ mt: 1 }}>
        <DataGrid
          title={
            <Text
              text="Danh sách miễn giảm học sinh"
              sx={{ fontSize: 16, fontWeight: 600 }}
            />
          }
          dataSource={dataSource}
          isLoading={status === PageBaseStatus.is_loading}
          height={window.innerHeight - 200}
          exportConfig={{
            enable: true,
            fileName: "danh-sach-mien-giam-hoc-sinh",
          }}
          filterRow={{
            enable: true,
          }}
          searchEnable={true}
          actionComponent={
            <Box sx={{ display: "flex" }}>
              <Box sx={{ ml: 2 }}>
                <ComboboxTruong
                  value={dm_truong_id}
                  onValueChanged={(value) => {
                    dispatch(changeTruong(value));
                  }}
                  isShowClearButton={true}
                  size="small"
                />
              </Box>
              <Box sx={{ ml: 2 }}>
                <ComboboxKhoi
                  dm_truong_id={dm_truong_id}
                  value={dm_khoi_id}
                  width={150}
                  onValueChanged={(value) => {
                    dispatch(changeKhoi(value));
                  }}
                  size="small"
                />
              </Box>
              <Box sx={{ ml: 2 }}>
                <ComboboxHe
                  width={150}
                  dm_khoi_id={dm_khoi_id}
                  dm_truong_id={dm_truong_id}
                  value={dm_he_id}
                  onValueChanged={(value) => {
                    dispatch(changeHe(value));
                  }}
                  size="small"
                />
              </Box>
              <Button
                sx={{ ml: 2 }}
                variant="default"
                size="small"
                leadingVisual={SyncIcon}
                onClick={() => {
                  dispatch(
                    loadGanMienGiamStart({
                      dm_he_id: dm_he_id,
                      dm_khoi_id: dm_khoi_id,
                      dm_truong_id: dm_truong_id,
                      nam_hoc: nam_hoc,
                    })
                  );
                }}
              >
                Làm mới
              </Button>
              <Button
                sx={{ ml: 2 }}
                variant="primary"
                size="small"
                leadingVisual={UploadIcon}
                onClick={() => {
                  dispatch(showGanMienGiamImportModal());
                }}
              >
                Import
              </Button>
            </Box>
          }
          columns={columns}
          paging={{
            enable: true,
            pageSize: 50,
            pageSizeItems: [50, 200, 500, 1000],
          }}
        />
      </Box>

      {is_show_filter_student_modal && (
        <GanMienGiamFilterStudentModal
          animationOf="#btnFilter"
          filterStudent={filterStudent}
          onClose={() => {
            dispatch(closeGanMienGiamFilterStudentModal());
          }}
          onSubmit={(filter: ganMienGiamFilterStudentModel) => {
            dispatch(changeGanMienGiamFilterStudent(filter));
            dispatch(closeGanMienGiamFilterStudentModal());
          }}
        />
      )}
      {is_show_approve_confirm && approve_request && (
        <AnimationConfirm
          animationOf={`btnApprove${approve_request?.sf_hinhthucmiengiam_id}`}
          onClose={() => {
            dispatch(approveGanMienGiamCancel());
          }}
          onConfirmed={() => {
            dispatch(approveGanMienGiamSubmit(approve_request));
          }}
          text={`Bạn có chắc chắn muốn ${approve_request.is_approved ? "áp dụng" : "bỏ áp dụng"
            } cho tất cả học sinh đang hiển thị`}
          type={approve_request.is_approved ? "success" : "danger"}
          is_saving={status === PageBaseStatus.is_saving}
          icon="fas fa-tasks"
          text_confirm_button={
            approve_request.is_approved ? "Áp dụng" : "Bỏ áp dụng"
          }
        />
      )}
      {is_show_import_modal && (
        <GanMienGiamImportModal
          nam_hoc={nam_hoc}
          animationOf="#btnImport"
          onClose={() => {
            dispatch(closeGanMienGiamImportModal());
          }}
          onSuccess={() => {
            dispatch(closeGanMienGiamImportModal());
            dispatch(
              loadGanMienGiamStart({
                dm_he_id: dm_he_id,
                dm_khoi_id: dm_khoi_id,
                dm_truong_id: dm_truong_id,
                nam_hoc: nam_hoc,
              })
            );
          }}
        />
      )}
    </Box>
  );
};
export default GanMienGiamNewPage;
